export enum OrderRefundReasonType {
  NOT_HAPPY = 'Not happy with the service',
  SLA = 'Missed SLA(s)',
  SOLD = 'Listing is pending/sold',
  PHOTOGRAPHY = 'Professional Photography selected by mistake',
  PACKAGE = 'Wrong package selected',
  PROMO = 'Promotion',
  OTHER = 'Other (specify reason)',
}
